export type ContactProfil = {
    id: number;
    code: string;
    name: string;
};

export enum ContactProfilsEnum {
    MANAGER = "MANAGER",
    PROJECT_MANAGER = "PROJECT_MANAGER",
    BILLING_MANAGER = "BILLING_MANAGER",
}
